<!-- 品控体系 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_product.jpg"
      class="banner"
    />
    <div :class="{ wrap: true, bg1: activeTab == 0, bg3: activeTab == 2 }">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <div class="thirdNavs">
          <div
            :class="{ nav: true, active: activeTab == 0 }"
            @click="changeTab(0)"
          >
            品控理念
          </div>
          <div
            :class="{ nav: true, active: activeTab == 1 }"
            @click="changeTab(1)"
          >
            品控机制
          </div>
          <div
            :class="{ nav: true, active: activeTab == 2 }"
            @click="changeTab(2)"
          >
            五心服务体系
          </div>
        </div>
      </div>
      <div class="tab" v-show="activeTab == 0">
        <div class="w1200">
          <sub-title title="品控理念" en="QUALITY CONTROL CONCEPT"></sub-title>
        </div>
        <div class="box1">
          <div class="in">
            高质量的咨询产品必须以客户需求为导向，项目总体目标为主线，以客户创造价值为核心，通过流程化、标准化、规范化的管理以及工作绩效考核，正向引导员工养成良好的职业行为习惯，才能确保咨询产品和服务的高品质。
          </div>
        </div>
      </div>
      <div class="tab" v-show="activeTab == 1">
        <div class="w1200">
          <sub-title
            title="品控机制"
            en="QUALITY CONTROL MECHANISM"
          ></sub-title>
          <div class="mechanism">
            1.
            好的品控机制不只是关注结果，更要关注形成结果的过程，作业流程、标准及操作规范，是咨询产品的品质保障;<br />
            2. 云控数智信息化管理系统，实现由线下到线上的信息化管理；<br />
            3.
            信息数智库（价值工程+工程指标+建造标准+典型案例+BIM）助力实现产品品质的提升和价值的再造。
          </div>
          <sub-title title="机制流程" en="MECHANISM FLOW"></sub-title>
          <img
            src="http://api.zyzxgc.cn/file/static/mechanism_flow.png"
            alt="机制流程"
            class="post"
          />
        </div>
      </div>
      <div class="tab" v-show="activeTab == 2">
        <div class="w1200">
          <sub-title
            title="五心服务体系"
            en="FIVE HEART SERVICE SYSTEM"
          ></sub-title>
        </div>
        <div class="box3">
          <img
            class="in"
            src="http://api.zyzxgc.cn/file/static/qualityServerSystem_img.png"
          />
          <div class="text text1">
            <div class="title">【安心】</div>
            <div class="sub">
              咨询服务成果经得起 客户、 行业、审计、 历史的检验
            </div>
          </div>
          <div class="text text2">
            <div class="title">【忠心】</div>
            <div class="sub">
              忠于国家<br />
              忠于客户<br />
              忠于团队
            </div>
          </div>
          <div class="text text3">
            <div class="title">【省心】</div>
            <div class="sub">
              以项目整体需求<br />
              与客户个性化需求<br />
              为咨询服务导向
            </div>
          </div>
          <div class="text text4">
            <div class="title">【匠心】</div>
            <div class="sub">
              以工匠极致的专业精神<br />
              定位咨询产品
            </div>
          </div>
          <div class="text text5">
            <div class="title">【舒心】</div>
            <div class="sub">
              以系统化、标准化、<br />
              规范化的成果文件、<br />
              咨询顾问服务、专业延伸<br />
              服务， 让客户舒心
            </div>
          </div>
        </div>
        <div class="m-box3">
          <img
            src="http://api.zyzxgc.cn/file/static/fiveStart.png"
            alt=""
            class="five"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      activeTab: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    if (this.$route.query.tab !== undefined) {
      this.activeTab = this.$route.query.tab;
    }
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    changeTab(idx) {
      this.$router.replace("/product/qualityControl?tab=" + idx);
      this.activeTab = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .bg1 {
    background-image: url("http://api.zyzxgc.cn/file/static/organization_bg.png");
  }
  .bg3 {
    background-image: url("http://api.zyzxgc.cn/file/static/qualityServerSystem_bg.png");
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .thirdNavs {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;

      .nav {
        font-size: 20px;
        color: #9a9a9a;
        line-height: 26px;
        cursor: pointer;

        &:hover {
          color: $theme;
          font-weight: bold;
        }

        & + .nav {
          margin-left: 35px;
        }
      }
      .active {
        color: $theme;
        font-weight: bold;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 37px;
          height: 3px;
          background-color: $theme;
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .tab {
    margin-bottom: 120px;
  }
  .box1 {
    margin-top: 30px;
    height: 800px;
    background-image: url("http://api.zyzxgc.cn/file/static/qualityIdea_img.png");
    background-size: cover;
    background-position-x: center;
    position: relative;

    .in {
      width: 600px;
      text-indent: 2em;
      line-height: 36px;
      border-radius: 20px;
      padding: 30px;
      box-sizing: border-box;
      color: #fff;
      font-size: 20px;
      background-color: rgba($color: #053a7a, $alpha: 0.8);
      position: absolute;
      top: 35px;
      left: 45%;
    }
  }
  .mechanism {
    margin: 50px 0 60px 20px;
    font-size: 15px;
    color: #5e5d5d;
    line-height: 30px;
  }
  .post {
    display: block;
    margin: 20px auto 0;
  }
  .box3 {
    width: fit-content;
    margin: 40px auto 0;
    position: relative;

    .in {
      width: 900px;
    }
    .text {
      width: 220px;
      text-align: center;
      color: #fff;
      font-size: 20px;
      position: absolute;

      .title {
        font-size: 21px;
        font-weight: bold;
      }
      .sub {
        line-height: 35px;
        margin-top: 10px;
      }
    }
    .text1 {
      top: 48px;
      left: 50%;
      transform: translateX(-50%);
    }
    .text2 {
      top: 282px;
      left: 10px;
    }
    .text3 {
      top: 282px;
      right: 10px;
    }
    .text4 {
      bottom: 65px;
      left: 130px;
    }
    .text5 {
      bottom: 43px;
      right: 139px;
    }
  }
  .m-box3 {
    display: none;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .thirdNavs {
        padding: 0 10px;
        margin-bottom: 30px;

        .nav {
          font-size: 16px;

          & + .nav {
            margin-left: 10px;
          }
        }
      }
    }
    .tab {
      margin-bottom: 20px;

      .w1200 {
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
    .box1 {
      height: 500px;
      padding: 20px 10px 0;
      box-sizing: border-box;

      .in {
        width: 100%;
        position: static;
        font-size: 16px;
      }
    }
    .mechanism {
      margin: 40px 0;
    }
    .post {
      width: 100%;
    }
    .box3 {
      display: none;
    }
    .m-box3 {
      margin: 40px 0;
      display: block;
      text-align: center;

      .five {
        width: 96%;
      }
    }
  }
}
</style>
